export default __webpack_public_path__ + "static/media/directions_bus_filled_24dp.1adceefa.svg";